import React, { useEffect, useState } from "react";
import styles from "./SupportChat.module.css";
import { Input, Button, Upload, Alert } from "antd";
import {
  FileOutlined,
  UploadOutlined,
  RollbackOutlined,
  PaperClipOutlined,
  SendOutlined,
} from "@ant-design/icons";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import {
  getMessageListApi,
  postSupportMessage,
} from "../../Api/BarestServices";
import { errorToast } from "./../../Toast/Toast";
import moment from "moment-jalaali";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faCheck,
  faCheckDouble,
} from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const SupportChat = () => {
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [fileList, setFileList] = useState([]);
  const [replyingTo, setReplyingTo] = useState(null); // State for reply
  const { id } = useParams();
  const history = useHistory();
  // Convert file to Base64
  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleSendMessage = async () => {
    if (inputValue.trim()) {
      const fileBase64 =
        fileList.length > 0 ? await getBase64(fileList[0].originFileObj) : null;
      let info = {
        support_id: id,
        message: inputValue,
        files: fileBase64 ? [fileBase64] : [],
        reply_to: replyingTo ? replyingTo.id : 0, // Add reply ID if replying
      };

      postSupportMessage(info, (succ, res) => {
        if (succ) {
          if (res.status === 1) {
            getMessageListHandler();
            setInputValue("");
            setFileList([]);
            setReplyingTo(null); // Reset reply after sending message
          } else {
            errorToast(res.message);
          }
        } else {
          console.error(res);
        }
      });
    }
  };

  const handleFileChange = ({ fileList }) => setFileList(fileList);

  useEffect(() => {
    getMessageListHandler();
    const intervalId = setInterval(() => {
      getMessageListHandler();
    }, 10000);
    return () => clearInterval(intervalId);
  }, []);

  const getMessageListHandler = () => {
    getMessageListApi(id, (succ, res) => {
      if (succ) {
        if (res.status === 1) {
          setMessages(res.support);
        } else {
          errorToast(res.message);
        }
      } else {
        console.error(res);
      }
    });
  };

  const handleReply = (message) => {
    setReplyingTo(message); // Set reply target
  };

  return (
    <div className={styles.chatContainer}>
      <div className={styles.titleHolder}>
        <h2>{messages?.title}</h2>
        <div
          className={styles.iconBack}
          style={{ color: "black" }}
          onClick={() => history.goBack()}
        >
          <FontAwesomeIcon icon={faArrowRight} style={{ fontSize: "1.4rem" }} color="#fff"/>
        </div>
      </div>
      {messages?.status === "1" ? (
        <Alert
          style={{ direction: "rtl" }}
          message=" ما درحال پیگیری درخواست شما هستیم! از شکیبایی شما سپاس گذاریم."
          banner
          closable
        />
      ) : null}
      {replyingTo && (
        <div className={styles.replyingTo}>
          <p className={styles.ReplyMessage}>
            در حال پاسخ به: {replyingTo.message}
          </p>
          <Button
            onClick={() => setReplyingTo(null)}
            style={{ marginLeft: "1rem" }}
          >
            لغو
          </Button>
        </div>
      )}

      <div className={styles.messagesContainer}>
        {messages?.chat?.map((message) => (
          <div
            key={message.id}
            className={
              message.sender === "client"
                ? styles.userMessage
                : styles.receivedMessage
            }
          >
            {message.reply_to !== 0 && (
              <div className={styles.replyMessageHolder}>
                <RollbackOutlined />:{" "}
                {
                  messages?.chat?.find((m) => m.id === message.reply_to)
                    ?.message
                }
              </div>
            )}
            <p className={styles.messageText}>{message.message}</p>
            {message?.files?.length !== 0 && (
              <p className={styles.linkHolder}>
                <a
                  href={`https://cdn.barest.ir/support/${message?.files[0]}`}
                  download={`https://cdn.barest.ir/support/${message?.files[0]}`}
                  className={styles.fileLink}
                >
                  {`فایل پیوست`} <FileOutlined />
                </a>
              </p>
            )}
            <div className={styles.messageDateStatus}>
              <span className={styles.messageDate}>
                {moment
                  .unix(parseInt(message.date))
                  .format("jYYYY/jM/jD--hh:mm")}
              </span>
              {message?.sender === "client"?message.status === "0" ? (
                <FontAwesomeIcon icon={faCheck} />
              ) : (
                <FontAwesomeIcon
                  icon={faCheckDouble}
                  color="rgb(187, 0, 134)"
                />
              ):null}
            </div>
            {message.sender !== "client" && (
              <button
                className={styles.replyIconHolder}
                onClick={() => handleReply(message)}
              >
                پاسخ
              </button>
            )}
          </div>
        ))}
      </div>

      {messages.status!=="2"&&<div className={styles.inputContainer}>
        <Input
          className={styles.inputField}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          placeholder="متن پیام..."
          onPressEnter={handleSendMessage}
        />
        <Upload
          beforeUpload={() => false}
          fileList={fileList}
          onChange={handleFileChange}
          showUploadList={false}
          accept=".png,.jpg,.jpeg,.pdf,.docx,.zip"
        >
          <Button icon={<PaperClipOutlined />} className={styles.uploadButton} style={{background:'lightgray',border:'none',borderRadius:'0'}}>
           
          </Button>
        </Upload>
        <Button
          type="primary"
          onClick={handleSendMessage}
          style={{ background: "rgb(187, 0, 134)", border: "none" }}
        >
          <SendOutlined rotate={180} style={{fontSize:'1rem',marginTop:'0.15rem'}} />
        </Button>
      </div>}
    </div>
  );
};

export default SupportChat;
